function MenuController(){
	this.className			= "MenuController";
	this.glob				= ["/**"];
	this.priority			= 999;
	this.globUseHash		= true;
}
MenuController.inheritsFrom( StandardController );
MenuController.prototype.swap = function(){
	this.state = nav.getState();

	if(!this.isSetup) this.setup();

	// console.log("Menu called", this.state.nextUrl, this.state.previousUrl);
	this.setSelected();


};
MenuController.prototype.setup = function(state){

	if(this.isSetup) return false;

	this.$body			 = $('body');
	this.$siteMenu 	 = this.$body.find('.js-site-menu');
	this.$menuItem   = this.$siteMenu.find('.js-menu-item');
	this.$menuLink   = this.$siteMenu.find('.js-menu-link');
	this.$menuButton = this.$body.find('.js-site-menu-button');
	this.$menuButtonLabel = this.$menuButton.find('.js-label');
	this.closeText = this.$menuButtonLabel.attr('data-text')

	// this.resizeDelegate = jstage.addListener('resize', () => this.onResize());
	this.onResize();

	this.isTablet = window.matchMedia('(min-width: 550px)');
	this.isTablet.addEventListener('change', () => {
		this.onResize();
	});

	this.duration  = 600;

	// Trigger on click / touch
	this.$menuButton.on('click touchstart', (e) => {
		if(e.cancelable) e.preventDefault(); //touchstart can't call preventDefault
		this.toggleMenu();
	}).on('touchend', (e) => {
		e.preventDefault(); //Call prevent default to stop the click
	});

	// Trigger on Keypress
	this.$body.on("keydown", (e) => {
		// Keypress: Escape
		if(e.which === 27) {
			e.preventDefault();
			e.stopPropagation();
			this.toggleMenu(true);
		}
	});

	// Close menu on link click
	this.$menuLink.on("click touchstart", (e) => {
		e.preventDefault();
		e.stopPropagation();
		const $this = $(e.currentTarget);

		// Set link state
		this.$menuItem.removeClass("selected");
		$this.parent('.js-menu-item').addClass('selected');

		// Close menu on same link
		if($this.attr("href") === this.state.nextUrl) {
			// debugger;
			this.toggleMenu(true);
		}
	}).each(function(){
		// Preload links
		jcache.getCache($(this).attr("href"));
	});

	// Update button label on click
	this.$menuLink.on("click", (e) => {
		const value = e.currentTarget?.dataset?.title;
		this.setButtonLabel(value)
	});

	// this.$siteMenu.find('.js-fit').css({
	// 	'height': this.$body.height() + 'px'
	// });

	this.isSetup = true;
}
MenuController.prototype.setSelected = function() {
	if(this.state.previousUrl && this.state.previousUrl !== this.state.nextUrl) {
		this.setButtonLabel();
	}

	const selectedMenu = this.getMeta()?.menu_main?.selected;
	if(!selectedMenu) return;

	this.$menuItem.removeClass("selected");
	const $menuItem = this.$menuItem.find(`[data-name="${selectedMenu.id}"]`);
	if($menuItem) $menuItem.parent().addClass("selected");
}
MenuController.prototype.setButtonLabel = function(text = false, toggle = null) {
	const menuLabel = this.getMeta()?.menu_label;
	// console.log("CHANGED MENU TEXT mainMenu", this.menuLabel);

	if(toggle !== null) {
		if(toggle) {
			text = this.menuLabel;
		} else {
			text = this.closeText;
		}
	}

	if(menuLabel && !text) {
		text = menuLabel;
	}

	if(!text) {
		text = "404";
	}

	const currentText = this.$menuButtonLabel.text();

	if(toggle === null && this.menuLabel === text && currentText === text) return;
	if(toggle === null) this.menuLabel = text;

	this.$menuButtonLabel.text(text);

	/*
	this.$menuButtonLabel.stop().fadeOut(0, function() {
		$(this).text(text).fadeIn(0);
	});
	*/
}
MenuController.prototype.onMousemove = function(e) {
	const element = document.querySelector('.site-menu__nav');
	const rect = element.getBoundingClientRect();
	const moveY = 1 - ((e.clientY - rect.top) / rect.height);

	gsap.to('.js-menu-link', {
		'--font-serif': moveY //(moveY * 14) - 14, // 0 to 1
	});
}
MenuController.prototype.menuOn = function() {
	console.log("Menu on!");

	this.setButtonLabel(false, false);
	this.$body.addClass('site-menu--open');

	this.mousemoveEvent = (e) => this.onMousemove(e);
	window.addEventListener("mousemove", this.mousemoveEvent);
}
MenuController.prototype.menuOff = function() {
	if(this.mousemoveEvent) window.removeEventListener('mousemove', this.mousemoveEvent);

	this.setButtonLabel(false, true);
	this.$body.removeClass('site-menu--open');
}
MenuController.prototype.toggleMenu = function(open, instant= false) {
	const isOpen = open ?? this.$body.hasClass('site-menu--open');

	if(isOpen) this.menuOff();
	else this.menuOn();
}
MenuController.prototype.onResize = function(){
	this.$siteMenu.css({
		'width': this.$menuButton.width() + 'px',
		'height': this.$menuButton.height() + 'px'
	});
}
MenuController.prototype.destroy = function() {

}